{
  "id": "soybean",
  "name": "Soybean",
  "species": "Glycine max",
  "ploidy": 2,
  "assembly": "Williams 82 (Wm82.a2.v1 / a4.v1 / a6.v1 naming)",
  "chromosomes": [
    "Gm01",
    "Gm02",
    "Gm03",
    "Gm04",
    "Gm05",
    "Gm06",
    "Gm07",
    "Gm08",
    "Gm09",
    "Gm10",
    "Gm11",
    "Gm12",
    "Gm13",
    "Gm14",
    "Gm15",
    "Gm16",
    "Gm17",
    "Gm18",
    "Gm19",
    "Gm20"
  ],
  "keys": [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20"
  ],
  "pattern": "^(?:glyma\\.wm82\\.gnm[0-9]+\\.(?:gm|chr)|glymachr|gm|chr|chromosome|lg)?[_\\s-]?0*([1-9]|1[0-9]|20)$",
  "sources": [
    "https://ftp.ncbi.nlm.nih.gov/genomes/all/GCF/000/004/515/GCF_000004515.6_Glycine_max_v4.0/GCF_000004515.6_Glycine_max_v4.0_assembly_report.txt",
    "https://rest.ensembl.org/info/assembly/glycine_max",
    "https://data.legumeinfo.org/Glycine/max/genomes/Wm82.gnm5.NRKG/README.Wm82.gnm5.NRKG.yml"
  ]
}
